module.exports = __webpack_public_path__ + "h5/img/questionTr.fb73ea89.jpg";